import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { OnDemandBillingResponseItem, OnDemandBillingTableData, OnDemandBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: OnDemandBillingResponseItem[],
  actions: OnDemandBillingTableRowActions
): OnDemandBillingTableData[] =>
  data.map((onDemandBillingItem: OnDemandBillingResponseItem) => {
    const { cost, amount, id, ...rest } = onDemandBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      amount: amount.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
